const menuConfig = [
  {
    title: "Statistik",
    iconPath: "/icons/Statistik.png",
    roles: ["City Admin"],
    subMenus: [
      { title: "Översikt", path: "/dashboard/overview" },
      { title: "Teamspelare", path: "/dashboard/team_player_analytics" },
      // { title: "Analytics", path: "/analytics" },
    ],
  },
  {
    title: "Admin Statistik",
    iconPath: "/icons/Statistik.png",
    roles: ["Admin"],
    subMenus: [
      { title: "Översikt", path: "/dashboard/admin_overview" },
      { title: "Analytics", path: "/dashboard/admin_analytics" },
      // { title: "Analytics", path: "/analytics" },
    ],
  },
  // {
  //   title: "Products",
  //   icon: "inventoryIcon", // Placeholder, replace with actual icon components
  //   subMenus: [{ title: "Create New Product", path: "/inventory/create" }],
  // },
  {
    title: "Lager",
    iconPath: "/icons/Lager.png",
    roles: ["City Admin"],
    subMenus: [
      {
        title: "Alla Lager",
        path: "/inventory/AllWarehouses",
      },
      {
        title: "Leveranser",
        path: "/inventory/add-products-to-warehouse",
        roles: ["City Admin"],
      },
      { title: "Artiklar",
        path: "/inventory/ViewProductsInWarehouse",
        roles: ["City Admin"]},
      // {
      //   title: "Sortiment",
      //   path: "/inventory/ViewProductsInWarehouse",
      //   roles: ["City Admin"],
      // },
      // { title: "Order Queue", path: "/inventory/fridges/OrderQueueList" },
    ],
  },
  {
    title: "Sortiment",
    iconPath: "/icons/Sortiment.png",
    roles: ["City Admin"],
    subMenus: [
      { title: "Kategorier", path: "/inventory/categories" },
      { title: "Teams", path: "/inventory/teams", requiresVoucherCustomer: true },
      { title: "Svinn", path: "/inventory/fridges/StealingHistory" },
      {
        title: "Enhetssortiment",
        path: "/inventory/products",
        roles: ["City Admin"],
      },
    ],
  },
  {
    title: "Ordrar",
    iconPath: "/icons/Ordrar.png",
    roles: ["City Admin"],
    subMenus: [
      { title: "Alla Ordrar", path: "/inventory/fridges/OrderQueueList" },
      // { title: "Orders", path: "/inventory/fridges/Orders" },
      { title: "Orderhistorik", path: "/inventory/fridges/OrderHistory" },
    ],
  },
  {
    title: "Kunder",
    iconPath: "/icons/Användare.png",
    roles: ["Admin"],
    subMenus: [
      // {
      //   title: "Create New Customer",
      //   path: "/inventory/customercreate",
      // },
      {
        title: "Alla Kunder",
        path: "/inventory/customerlist",
      },
    ],
  },
  {
    title: "Enheter",
    iconPath: "/icons/Enheter.png",
    roles: ["Admin", "City Admin"],
    subMenus: [
      {
        title: "Alla Enheter",
        path: "/inventory/all-fridges",
      },
      {
        title: "Karta",
        path: "/inventory/fridges-map",
      },

      // {
      //   title: "Transfer Product To Fridge",
      //   path: "/inventory/transfer-to-fridge",
      // },

      // {
      //   title: "Fridge Treshold",
      //   path: "/inventory/fridge-treshold",
      // },
      // {
      //   title: "Orders Queue",
      //   path: "/inventory/order-queue",
      // },
    ],
  },
  // {
  //   title: "Missing",
  //   icon: "dashboardIcon",
  //   roles: ["City Admin"],
  //   subMenus: [
  //     { title: "Stealing", path: "/inventory/fridges/StealingHistory" },
  //     { title: "Expiration", path: "#" },
  //     { title: "Gift", path: "#" },
  //   ],
  // },
  {
    title: "Användare",
    iconPath: "/icons/Användare.png",
    roles: ["City Admin"],
    subMenus: [{ title: "Alla Användare", path: "/auth/users" }],
  },
  {
    title: "Köp",
    iconPath: "/icons/Köp.png",
    roles: ["City Admin"],
    subMenus: [{ title: "Köphistorik", path: "/inventory/payment/PaymentHistory" }],
  },

  {
    title: "Kommunikation",
    roles: ["City Admin"],
    iconPath: "/icons/Kommunikation.png",
    subMenus: [{ title: "Chatt", path: "/chat/Inbox" }],
  },

  {
    title: "Stöldskydd",
    iconPath: "/icons/stöldskydd.png",
    roles: ["City Admin"],
    subMenus:
        [
            { title: "Videos", path: "/settings/videos" },
        { title: "Errands", path: "/settings/errands" },
          { title: "User Errands", path: "/settings/usererrands" }
    ],
  },
  // {
  //   title: "Inställningar",
  //   icon: "dashboardIcon",
  //   roles: ["Admin"],
  //   subMenus: [
  //     { title: "Keys", path: "/settings/keys" },
  //   ],
  // },
  {
    title: "Inställningar",
    iconPath: "/icons/Inställningar.png",
    roles: ["City Admin"],
    subMenus: [
      { title: "Mina inställningar", path: "/settings/settings" },
      { title: "QR-nyckel", path: "/settings/qrcode" }
    ],
  },

];

export default menuConfig;
